var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"answer"},[_c('div',{staticClass:"title"},[_vm._v("解答：")]),_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.row.answer)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }